import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/** Reset scroll to top on route changes (React Router does not do this by
 *  default). Hash-based deep links (e.g. `/admin/yachts/:id#photos`) still
 *  scroll to the anchor instead of top.
 *
 *  Instant scroll (not smooth) — otherwise the user sees the previous page
 *  briefly then a scroll animation, which feels worse than the bug.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
    }
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);

  return null;
}
